import * as api from '../api';

export const fetchAllProgramsActions = api.fetchActions('programs', 'fetch-all-programs');

export const actionTypes = {
  ...fetchAllProgramsActions.actionTypes,
}

/**
 * Get the set of all programs for the current organization; stored at programs.allprograms
 */
export const fetchAllPrograms = (noAuth = false) => api.shouldExecute(['programs', 'allPrograms'],
  api.getThunk(`/programs`, {}, fetchAllProgramsActions, null, noAuth ? api.unauthorizedConfig : {}));



// WEBPACK FOOTER //
// src/programs/program.actions.js